import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchDocumentGet } from '../../redux/slices/documentGetSlice'
import { fetchDocumentCreate } from '../../redux/slices/documentCreateSlice'
import { fetchDocumentUpdate } from '../../redux/slices/documentUpdateSlice'
import { ToSeoUrl } from '../../components/general/SeoUrl'
import { FiFile } from 'react-icons/fi'

const CrudDocument = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ file: null })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchDocumentGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    slugtr: data.payload?.slug["tr"],
                    slugen: data.payload?.slug["en"],
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], titletr: "", titleen: "", slugtr: "", slugen: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": ToSeoUrl(formData.titletr), "en": ToSeoUrl(formData.titleen) }
        const description = {}
        const content = {}

        let files = []
        if (formData.file) {
            if (formData.file instanceof FileList) {
                const fileObj = formData.file[0];
                files.push({ file: fileObj });
            }
            else if (formData.file instanceof File) {
                files.push({ file: formData.file });
            }
            else if (Array.isArray(formData.file)) {
                files = formData.file;
            }
            else {
                console.log("Dosya uygun formatta değil:", formData.file);
            }
        }
        console.log(files)

        await dispatch(
            selectedItem === 0 ?
                fetchDocumentCreate({ file: files, title: title, slug: slug, description: description, content: content }) :
                fetchDocumentUpdate({ id: selectedItem, file: files, title: title, slug: slug, description: description, content: content })
        )
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_document" : "edit_document")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <FormItem
                        id={`file`}
                        name={`file`}
                        type="file"
                        icon={<FiFile size={20} />}
                        title={`${t("document")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='file'
                    />
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudDocument